import React from 'react';
import { CopyCard, CopyField, setPageCopySection } from './adminSiteCopyFields';

export default function AdminSiteHomeSectionsFields({ form, setField }) {
  const home = form.page_copy?.home || {};
  const setHome = (patch) => setPageCopySection(form, setField, 'home', patch);

  return (
    <>
      <CopyCard title="Collections grid" subtitle="First catalog section on the homepage">
        <CopyField
          id="home-collections-title"
          label="Section title"
          value={home.collections_title || ''}
          onChange={(v) => setHome({ collections_title: v })}
        />
        <CopyField
          id="home-collections-lead"
          label="Lead text"
          value={home.collections_lead || ''}
          onChange={(v) => setHome({ collections_lead: v })}
          multiline={2}
        />
      </CopyCard>

      <CopyCard title="Shop by style" subtitle="Style tiles from your catalog">
        <CopyField
          id="home-style-title"
          label="Section title"
          value={home.shop_by_style_title || ''}
          onChange={(v) => setHome({ shop_by_style_title: v })}
        />
        <CopyField
          id="home-style-lead"
          label="Lead text"
          value={home.shop_by_style_lead || ''}
          onChange={(v) => setHome({ shop_by_style_lead: v })}
          multiline={2}
        />
      </CopyCard>

      <CopyCard title="Curated looks & featured" subtitle="Featured picks and product carousel">
        <CopyField
          id="home-curated-title"
          label="Curated looks title"
          value={home.curated_title || ''}
          onChange={(v) => setHome({ curated_title: v })}
        />
        <CopyField
          id="home-curated-featured"
          label="Curated subtitle (when featured products are set)"
          value={home.curated_subtitle_featured || ''}
          onChange={(v) => setHome({ curated_subtitle_featured: v })}
          multiline={2}
        />
        <CopyField
          id="home-curated-default"
          label="Curated subtitle (auto from catalog)"
          value={home.curated_subtitle_default || ''}
          onChange={(v) => setHome({ curated_subtitle_default: v })}
          multiline={2}
        />
        <CopyField
          id="home-featured-title"
          label="Featured products title"
          value={home.featured_title || ''}
          onChange={(v) => setHome({ featured_title: v })}
        />
      </CopyCard>

      <CopyCard title="Instagram section" subtitle="Below gift & styling ideas on homepage">
        <CopyField
          id="home-instagram-title"
          label="Section title"
          value={home.instagram_title || ''}
          onChange={(v) => setHome({ instagram_title: v })}
        />
        <CopyField
          id="home-instagram-subtitle"
          label="Subtitle"
          value={home.instagram_subtitle || ''}
          onChange={(v) => setHome({ instagram_subtitle: v })}
          multiline={2}
        />
        <CopyField
          id="home-instagram-button"
          label="Profile button label"
          value={home.instagram_button || ''}
          onChange={(v) => setHome({ instagram_button: v })}
        />
        <CopyField
          id="home-instagram-empty"
          label="Empty state message"
          value={home.instagram_empty || ''}
          onChange={(v) => setHome({ instagram_empty: v })}
        />
      </CopyCard>

      <CopyCard title="Exhibitions section" subtitle="Show schedule intro (shows managed in Admin → Shows)">
        <CopyField
          id="home-exhibitions-eyebrow"
          label="Eyebrow"
          value={home.exhibitions_eyebrow || ''}
          onChange={(v) => setHome({ exhibitions_eyebrow: v })}
        />
        <CopyField
          id="home-exhibitions-title"
          label="Section title"
          value={home.exhibitions_title || ''}
          onChange={(v) => setHome({ exhibitions_title: v })}
        />
        <CopyField
          id="home-exhibitions-subtitle"
          label="Subtitle"
          value={home.exhibitions_subtitle || ''}
          onChange={(v) => setHome({ exhibitions_subtitle: v })}
          multiline={3}
        />
      </CopyCard>
    </>
  );
}
